module.exports = __webpack_public_path__ + "img/borderCornerRightWhite.13816c99.svg";